import { getObjectValue } from '../../object-extensions';

export class JsonResponseParser {
  /**
   * The path to the key embedding the response data of interest.
   */
  contentProperty;

  constructor(contentProperty = 'data.payload') {
    this.contentProperty = contentProperty;
  }

  /**
   * Parses the response into a JSON.
   * @param {*} response
   */
  parse(response) {
    const data = this.contentProperty ? getObjectValue(response, this.contentProperty) : response;

    return data;
  }
}
